import React, { useEffect } from 'react';
import { ScommesseListItem, ScommesseQuoteListProps } from '.';

import { ScommesseLeafItem } from '../cells';
import classNames from 'classnames';
import { isTruthy } from 'utility/functions';
import styles from './ScommesseQuoteList.module.scss';
import { useScrollPositionContext } from '../scommesseTableQuotaSelect/context/ScrollPositionContext';
import useWindowSize from 'hooks/useWindowSize';

export const ScommesseQuoteList = ({
  type,
  headerList,
  optionsKeys,
  bilanciataKey,
  scommessaKey,
  selectedOptionKey,
  infoAggiuntivaKey,
  setIsOpen,
  onOptionSelected,
}: ScommesseQuoteListProps) => {
  const [mainHeader, ...othHeader] = headerList ?? [];

  const { isMobile } = useWindowSize();

  const { scrollPosition } = useScrollPositionContext();

  const ScommesseQuoteListItemClickHandler = (esitoKey: string) => {
    if (typeof onOptionSelected === 'function') {
      onOptionSelected(esitoKey);
    }
    if (isMobile) {
      window.scrollTo(0, scrollPosition);
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (!selectedOptionKey && isTruthy(optionsKeys?.length)) {
      if (typeof onOptionSelected === 'function') {
        // 0 or bilanced?
        onOptionSelected(optionsKeys[0]);
      }
    }
  }, [selectedOptionKey, optionsKeys, onOptionSelected]);

  // const infoAggIndex = useInfoAggiuntivaIndex(itemKey)

  const itemDisabled = optionsKeys?.length < 2;
  return (
    <React.Fragment>
      {mainHeader && (
        <div className={styles.headersList}>
          <span className={styles.headerCheck} />
          <span className={classNames(styles.header, styles.first)} suppressHydrationWarning>
            {mainHeader}
          </span>
          <ul className={styles.list}>
            {othHeader?.map((el, idx) => (
              <li key={idx} className={classNames(styles.header, styles.single)} suppressHydrationWarning>
                {el}
              </li>
            ))}
          </ul>
        </div>
      )}
      {
        /* verificare - non mi torna il giro - qua le opzioni sono infoAggiuntiva, non esito */
        optionsKeys?.map((key) => (
          <ScommesseListItem
            key={key}
            type={type}
            itemKey={key}
            disabled={itemDisabled}
            isSelected={key === selectedOptionKey}
            isBilanciata={key === bilanciataKey}
            scommessaKey={scommessaKey}
            infoAggiuntivaKey={
              [`${ScommesseLeafItem.InfoAggiuntivaWithEsito}`, `${ScommesseLeafItem.InfoAggiuntiva}`].includes(type)
                ? key
                : infoAggiuntivaKey
            }
            onClick={ScommesseQuoteListItemClickHandler}
          />
        ))
      }
    </React.Fragment>
  );
};
